import {IMusic} from "../models/IMusic";

const StorageHelper = {
    set: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
    get: (key) => {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    remove: (key) => localStorage.removeItem(key),
    clear: () => localStorage.clear(),

    loadMusicSettings: (): Partial<IMusic> => {
        const keys: (keyof IMusic)[] = [
            'playMusic',
            'playTutorial',
            'playMenu',
            'playBattle',
        ];

        const musicPatch: Partial<IMusic> = {};

        keys.forEach((key) => {
            const value = StorageHelper.get(key);

            if (value === true || value === 'true') {
                musicPatch[key] = true;
            }

            if (value === false || value === 'false') {
                musicPatch[key] = false;
            }
        });

        return musicPatch;
    }
};
export default StorageHelper;